<template>
  <div :class="['col-12', 'wc-row', 'allegati-wc-row']"
       @click="goToUrl(item.url)">
    <div class="row">
      <!--ROW -->
      <div class="col-12 allegati-row">
        <div v-if="!loading">
          <!--Icon -->
          <i :class="[
            'allegati-icon',
            'fa-regular ' + item.fa_icon
            ]"
             aria-hidden="true"></i>
          <!--Title -->
          <span class="allegati-text allegati-text-title">
            {{ item.title }}
          </span>
          <!--Extension Size -->
            <span class="allegati-text allegati-text-extension">({{ item.extension }} </span>
            <span class="allegati-text allegati-text-size">{{ item.file_size }})</span>
        </div>
        <BSkeleton v-else
                   width="75%"/>
      </div>
    </div>
  </div>
</template>

<script>
import { BSkeleton } from "bootstrap-vue";

export default {
  name: "Row",
  components: {
    BSkeleton
  },
  props: {
    item: {
      type: Object,
      default: function(){
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToUrl(url){
      window.location.href = url;
    }
  }
};
</script>
